import { Box, useTheme } from '@mui/material';

import { Button } from '@verantos-dev/shared-components';

export interface ErrorWithRetryButtonProps {
  onRetry: () => void;
  message: string;
}

export const ErrorWithRetryButtonCard = ({ onRetry, message }: ErrorWithRetryButtonProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        marginLeft: theme.spacing(0.5),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
      }}
    >
      <Box>{message}</Box>
      <Button
        id="refresh-button"
        onClickHandler={onRetry}
        displayLabel="Refresh"
        variant="outlined"
        size="small"
        sx={{ width: 'fit-content' }}
      />
    </Box>
  );
};
